import { render, staticRenderFns } from "./boardMonthlyBalance.vue?vue&type=template&id=3d3dd168&scoped=true&"
import script from "./boardMonthlyBalance.vue?vue&type=script&lang=js&"
export * from "./boardMonthlyBalance.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3d3dd168",
  null
  
)

export default component.exports